"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringToLowercaseTransform = void 0;
// Define the transformation function
const StringToLowercaseTransform = ({ value }) => {
    return value?.toLowerCase();
};
exports.StringToLowercaseTransform = StringToLowercaseTransform;
